import { config } from 'config';
import { LocalStorage } from 'libs/common';
import { SocketApi } from './socket';

// ws
export const socket = new SocketApi(config.network?.socket_url, new LocalStorage('api'));

export default socket;
